<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <filter-manager
      ref="filterRef"
      :filters="filtersConfig"
      :display-advanced="false"
      search-icon="fa fa-sync pr-2"
      search-text=""
      search-container-class="d-flex align-items-center justify-content-end"
      v-model="filterModel"
      @search="onProcessHandler"
    >
      <div class="col d-flex justify-content-end align-items-center">
        <dropdown
          v-if="canQueue"
          icon="fas fa-print"
          :items="reportOptions"
          title="Seleccione"
        />
      </div>
    </filter-manager>
    <queue-report-status
      :queue-report="queueInfo"
      @on-cancel="cancelQueue"
      @on-download="downloadQueueReport"
    />
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import Dropdown from 'dropdown'

//services
import AcademicYearServices from '@/services/api/academicyear.api'
import ReportServices from '@/modules/report/api'
import hubService from "@/services/api/hub/hubservice.js";

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'

//constants
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'
import QueueReportStatus from "@/views/progress/shared/components/QueueReportStatus.vue";
import Vue from "vue";
import DocumentServices from "@/modules/report/document";
import queueReportTypes from "@/utils/constants/queueReportTypes";
import queueReportStatus from "@/utils/constants/queueReportStatus";

export default {
  name: 'MonthlyReportInvoiceRP',
  components: {
    QueueReportStatus,
    PageHeader,
    FilterManager,
    Dropdown,
  },
  mixins: [alertMixin],
  data: () => ({
    queueInfo: null,
    filterOptions: {
      academicYears: [],
      months: [],
    },
    filterModel: {
      academicYear: null,
      month: null,
    },
  }),
  computed: {
    canQueue() {
      return this.queueInfo === null
        || this.queueInfo.statusId === queueReportStatus.Completed
        || this.queueInfo.statusId === queueReportStatus.Failed
    },
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Informe Mensual de Facturas Recibidas de Remedio Provisional',
        routes: [
          'Inicio',
          'Reportes',
          'Informe Mensual de Facturas Recibidas de Remedio Provisional',
        ],
      }
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-4',
          options: this.filterOptions.academicYears,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Mes',
          error: 'El mes es requerido.',
          validations: 'required',
          options: this.filterOptions.months,
        },
      ]
    },
    reportOptions() {
      return [
        {
          label: 'Excel',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(false),
        },
        {
          label: 'PDF',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(true),
        },
      ]
    },
  },
  async mounted() {
    await this.getInitialFilters()
    const res = await ReportServices.getPreviousGeneratedReport([queueReportTypes.BillingSubmittedPeriodReportExcel, queueReportTypes.BillingSubmittedPeriodReportPdf])
    this.queueInfo = res.data !== '' ? res.data : null;
  },
  created() {
    Vue.use(hubService)
    this.$userHub.$on('hub-receive-status-queue-report', this.updateReceivedQueueStatusByHub)
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off('hub-receive-status-queue-report', this.updateReceivedQueueStatusByHub)
  },
  methods: {
    async downloadQueueReport(executionLogId) {
      ReportServices.downloadQueueReport(executionLogId)
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast("", err.response?.data?.message, "error");
        });
    },
    async cancelQueue(executionLogId) {
      ReportServices.cancelQueueReport(executionLogId)
        .then((res) => {
          if (res.data) {
            this.ShowToast(
              'Proceso Exitoso',
              'La ejecución del reporte ha sido cancelada exitosamente.',
              'success'
            );
            this.queueInfo = null;
          }
        })
        .catch((err) => {
          this.ShowToast("", err.response?.data?.message, "error");
        });
    },
    updateReceivedQueueStatusByHub(res) {
      this.queueInfo = res.respose;
    },
    async getInitialFilters() {
      this.filterOptions.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data
    },
    async onChangeAcademicYear() {
      this.filterModel.month = null
      this.filterOptions.months = []

      await this.getMonthsInAcademicYear()
    },
    async getMonthsInAcademicYear() {
      this.filterOptions.months = (
        await AcademicYearServices.getMonthsInAcademicYear(
          this.filterModel.academicYear.id
        )
      ).data
    },
    async onProcessHandler(isPdfFormat) {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      ReportServices.queueReport('rpmonthlyreportinvoice', {
        academicYearId: this.filterModel.academicYear.id,
        month: this.filterModel.month.id,
        isPdfFormat,
      }).then(res => {
        this.queueInfo = {
          executionLogId: res.data,
          statusId: queueReportStatus.Pending,
          expired: false
        }
      });
    },
  },
}
</script>
